import React, { useState, useEffect } from 'react'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import MDInput from 'components/MDInput'
import MDButton from 'components/MDButton'
import Editor from 'components/editor'
import { useAppServices } from 'hook/services'
import { useParams } from 'react-router-dom'

const EditModal = ({ editData, handleRefresh, index, appData, appCollections }) => {
  const [open, setOpen] = useState(false)
  const [exisitingData, setExistingData] = useState({})
  const [name, setName] = useState('')
  const [description, setDescription] = useState('')
  const [loading, setLoading] = useState(false)

  // Populate initial values when `editData` changes
  useEffect(() => {
    if (editData) {
      setName(editData.name || '')
      setDescription(editData.description || '')
    }
  }, [editData])

  console.log('editData', editData)

  const params = useParams()

  const AppService = useAppServices()

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)

    const newEntry = { name, description }

    // Check if document exists
    const { response: existingDoc } = await AppService.partner_module.get({
      query: `partner_id=${params.partner_id}`,
    })

    let res
    if (existingDoc?.data?.length) {
      const currentData = existingDoc.data[0]
      const updatedPartnerData = [...currentData.partner_data] // clone array

      updatedPartnerData[index] = newEntry // update at index

      const updatedPayload = {
        partnerId: params.partner_id,
        partner_data: updatedPartnerData,
      }

      res = await AppService.partner_module.update({
        payload: updatedPayload,
      })
    }

    setLoading(false)
    setOpen(false)
    setName('')
    setDescription('')
    handleRefresh()
  }

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  }

  return (
    <>
      <MDButton sx={{ ml: 2 }} color="info" onClick={() => setOpen(true)}>
        Edit
      </MDButton>

      <MDModal open={open} onClose={() => setOpen(false)}>
        <MDBox component="form" onSubmit={handleSubmit} sx={style}>
          <MDTypography variant="h5" mb={2}>
            Edit Partner Info
          </MDTypography>

          <MDBox mb={2}>
            <MDTypography variant="button">Name</MDTypography>
            <MDInput
              fullWidth
              value={name}
              onChange={(e) => setName(e.target.value)}
              name="name"
              required
            />
          </MDBox>

          <MDBox mb={2}>
            <MDTypography variant="button">Description</MDTypography>
            <Editor handleChange={(val) => setDescription(val)} data={description} />
          </MDBox>

          <MDBox display="flex" justifyContent="flex-end">
            <MDButton
              variant="gradient"
              color="secondary"
              onClick={() => setOpen(false)}
              sx={{ mt: 2, mr: 1 }}
            >
              Cancel
            </MDButton>
            <MDButton
              variant="gradient"
              color="primary"
              type="submit"
              loading={loading}
              disabled={loading}
              sx={{ mt: 2 }}
            >
              Submit
            </MDButton>
          </MDBox>
        </MDBox>
      </MDModal>
    </>
  )
}

export default EditModal
